import React, { useState, useEffect } from 'react';

// Rate limiting utilities (duplicated for component independence)
const RATE_LIMIT_KEY = 'wpp_rate_limit_state';

const getRateLimitState = (): { isRateLimited: boolean; waitTime: number } => {
  try {
    const stored = localStorage.getItem(RATE_LIMIT_KEY);
    if (!stored) return { isRateLimited: false, waitTime: 0 };
    
    const state = JSON.parse(stored);
    const now = Date.now();
    const waitTime = Math.max(0, state.rateLimitedUntil - now);
    
    return {
      isRateLimited: waitTime > 0,
      waitTime
    };
  } catch {
    return { isRateLimited: false, waitTime: 0 };
  }
};

interface RateLimitIndicatorProps {
  className?: string;
}

export const RateLimitIndicator: React.FC<RateLimitIndicatorProps> = ({ className = '' }) => {
  const [rateLimitState, setRateLimitState] = useState(getRateLimitState());

  useEffect(() => {
    const updateRateLimitState = () => {
      setRateLimitState(getRateLimitState());
    };

    // Update every second when rate limited
    const interval = setInterval(updateRateLimitState, 1000);

    return () => clearInterval(interval);
  }, []);

  if (!rateLimitState.isRateLimited) {
    return null;
  }

  const waitMinutes = Math.ceil(rateLimitState.waitTime / 60000);
  const waitSeconds = Math.ceil((rateLimitState.waitTime % 60000) / 1000);

  return (
    <div 
      className={`flex items-center gap-2 p-3 rounded-lg bg-yellow-50 border border-yellow-200 ${className}`}
      style={{
        background: 'linear-gradient(135deg, var(--wa-warning-50), var(--wa-yellow-50))',
        border: '1px solid var(--wa-warning-200)',
        color: 'var(--wa-warning-800)'
      }}
    >
      <div 
        className="animate-pulse"
        style={{ 
          width: '8px', 
          height: '8px', 
          backgroundColor: 'var(--wa-warning-500)',
          borderRadius: '50%'
        }}
      />
      <span style={{ fontSize: 'var(--wa-text-sm)', fontWeight: 'var(--wa-font-medium)' }}>
        ⏳ Rate limit ativo: aguarde {waitMinutes > 0 ? `${waitMinutes}m ` : ''}{waitSeconds}s
      </span>
    </div>
  );
};

export default RateLimitIndicator;